import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { Row, FormControl } from "react-bootstrap";

import find from "lodash/find";

const DropdownSearchSelect = ({
  name,
  data,
  value,
  disabled,
  placeholder,
  required,
  onChange,
  onOptionClick,
  label
}) => {
  const [selected, setSelected] = useState({});
  const menu = useRef(null);

  useEffect(() => {
    const obj = find(data, { value });
    setSelected(obj);
  }, [data, value]);

  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (onOptionClick) {
        onOptionClick(e);
      }
    };

    const currentTarget = menu.current;

    currentTarget.addEventListener("contextmenu", handleContextMenu);
    return () => {
      currentTarget.removeEventListener("contextmenu", handleContextMenu);
    };
  }, [onOptionClick]);

  const handleChange = (e) => {
    onChange(name, { label: name, value: e.target.value });
  };

  return (
    <Row className="form-group form-group--select">
      <div ref={menu}>
        {label && (
          <label
            className="control-label"
            htmlFor={name}
            style={{ textTransform: "uppercase" }}
          >
            {label} {required && "*"}
          </label>
        )}
        <FormControl
          componentClass="select"
          required={required}
          name={name}
          value={selected?.value || ""}
          onChange={handleChange}
          placeholder={placeholder || "Please Select..."}
          disabled={disabled}
        >
          <option aria-label="Select" value="" />
          {data.map((d, i) => (
            <option key={i} value={d.value}>
              {d.label}
            </option>
          ))}
        </FormControl>
      </div>
    </Row>
  );
};

DropdownSearchSelect.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  data: PropTypes.array,
  required: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onOptionClick: PropTypes.func
};

DropdownSearchSelect.defaultProps = {
  label: null
};

export default DropdownSearchSelect;
